"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../../utils/validations");
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
const StreamPartID_1 = require("../../../utils/StreamPartID");
class InstructionMessage extends TrackerMessage_1.default {
    constructor({ version = TrackerMessage_1.default.LATEST_VERSION, requestId, streamId, streamPartition, nodeIds, counter }) {
        super(version, TrackerMessage_1.default.TYPES.InstructionMessage, requestId);
        (0, validations_1.validateIsNotEmptyString)('streamId', streamId);
        (0, validations_1.validateIsNotNegativeInteger)('streamPartition', streamPartition);
        (0, validations_1.validateIsArray)('nodeIds', nodeIds);
        (0, validations_1.validateIsNotNegativeInteger)('counter', counter);
        this.streamId = streamId;
        this.streamPartition = streamPartition;
        this.nodeIds = nodeIds;
        this.counter = counter;
    }
    getStreamPartID() {
        return (0, StreamPartID_1.toStreamPartID)(this.streamId, this.streamPartition);
    }
}
exports.default = InstructionMessage;
//# sourceMappingURL=InstructionMessage.js.map